import type { KbThreadArchiveReasonValue } from '@/api/kb-client';

// =============================================================================
// kb-format.ts — Libellés FR de la KNOWLEDGE BASE (R15-COM-04). Sens TOUJOURS textuel.
// =============================================================================
// WCAG 2.1 AA : chaque motif d'archivage porte un LIBELLÉ TEXTE explicite (la couleur n'est jamais le
// seul porteur d'information). Aucune règle métier ici : mise en forme pure. Les dates et le rôle
// d'émetteur réutilisent `chat-format.ts` (formatDateTime / senderRoleLabel) — pas de duplication.

/** Libellé FR du motif d'archivage d'un fil (parité base), ou « — » si inconnu. */
export function archiveReasonLabel(
  reason: KbThreadArchiveReasonValue | null,
): string {
  switch (reason) {
    case 'CycleClosed':
      return 'Cycle clôturé';
    case 'NegoClosed':
      return 'Négociation clôturée';
    case 'Abandoned':
      return 'Abandonné';
    case null:
      return '—';
  }
}
